module.exports = __webpack_public_path__ + "img/GBM1_CD4Tconv.33f348aa.png";